import emojiRegex from 'emoji-regex';

export const ellipsis = (text: string, length: number) =>
  text.length <= length ? text : `${text.slice(0, length - 3)}...`;

// 이모지를 count 하는게 불가능 하기 때문에 이모지를 문장에서 제거 하고 나머지 개수가 없는지로 확인
export const hasSingleEmoji = (text: string) =>
  text.match(emojiRegex())?.length === 1 && text.replace(emojiRegex(), '').length === 0;

export const shortenCount = (origin: number) => {
  if (!origin) {
    return '0';
  }

  const getFixedNum = (num: number) => Math.round((num + Number.EPSILON) * 10) / 10;

  if (origin < 1000) {
    return `${origin}`;
  }
  if (origin < 10000) {
    return `${getFixedNum(origin / 1000)}천`;
  }
  if (origin < 100000000) {
    return `${getFixedNum(origin / 10000)}만`;
  }
  return `${getFixedNum(origin / 100000000)}억`;
};

export const getLabelWithCount = (label: string, count: number, standard = 10) => {
  if (!count) {
    return label;
  }
  if (count < standard) {
    return `${label} ${count}`;
  }
  return shortenCount(count);
};

export const pad = (d: number) => (d < 10 ? `0${d.toString()}` : d.toString());

export const numberComma = (d: number) => d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const toKebabCase = (str: string) =>
  str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();

// 개행 문자를 공백으로 변환하고 앞뒤 공백을 제거합니다. whiteSpace: 'normal'과 동일
export const toWhiteSpaceString = (text?: string) => {
  if (!text) {
    return '';
  }

  return text.replace(/[ \t\f\v]*[\r\n\u2028\u2029]+[ \t\f\v]*/g, ' ').trim();
};
